import React, {ComponentProps} from 'react';
import {ThemeProvider} from '@rn-vui/themed';

import rewardsTheme from '../../../theme/rewardsTheme';
import {EmptyCart} from '../components/EmptyCart';

import CartScreenLoyaltyEnabled from './CartScreenLoyaltyEnabled';

type Props = ComponentProps<typeof CartScreenLoyaltyEnabled>;

export default (props: Props) => (
  <ThemeProvider theme={rewardsTheme}>
    <CartScreenLoyaltyEnabled {...props} />
  </ThemeProvider>
);

// Re-export EmptyCart for use in other components
export {EmptyCart};
